<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    scrollable
  >

    <v-btn
      slot="activator"
      color="green accent-3"
      class="mb-2"
      block
      dark
      :small="$vuetify.breakpoint.smAndDown"
    >
      Tietoa torilivestä
    </v-btn>

    <v-card class="more-info-card">
      <v-card-title class="headline pb-0">
        <v-layout>
          <v-flex class="pt-1">
            Tietoa torilivestä
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon color="grey">close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text class="pt-0">

        <h3>Mikä on Torilive?</h3>
        <p>
          Torilive on webkamera, josta voi katsella Turun uutta kauppatoria livenä.
        </p>

        <h3>Miksi Torilive on toteutettu?</h3>
        <p>
          Turun tori on uudistunut merkittävällä tavalla.
          On mielenkiintoista nähdä Turun ytimen elämää livenä.
        </p>

        <h3>Kuka on toteuttanut Toriliven?</h3>
        <p>
          Toriliven idea ja toteutus syntyivät Taisteen henkilöstön keskuudessa.
          Toteutimme tämän oppiaksemme uutta ja ilahduttaaksemme kaikkia Turun kauppatorista kiinnostuneita.
        </p>

        <h3>Mikä tai kuka on Taiste?</h3>
        <p>
          Taiste on kotimainen digitaalisia palveluja suunnitteleva ja toteuttava yritys.
          Yhdistämme töissämme huipputason asiakasymmärryksen, käytettävyyden ja teknisen toteutuksen.
          <a href="https://www.taiste.fi">Tutustu Taisteeseen täällä.</a>
        </p>

        <h3>Miksi Taiste halusi toteuttaa sen?</h3>
        <p>
          Turun toimistomme sijaitsee KOP-Kolmion kuudennessa kerroksessa, josta avautuu hyvä näköala torille.
          Kauppatorin rakennustyömaan eteneminen oli meidän mielestämme niin kiinnostavaa katseltavaa, että halusimme
          avata muillekin mahdollisuuden seurata sitä. Meidän työssämme design ja teknologia yhdistyvät
          digitaalisessa muodossa, mutta torin työmaalla niin tapahtui aivan konkreettisesti!
          Tori on valmistunut ja nyt on ilo seurata etänä kauppatorin elämää vaikka emme olisi Turussa paikalla.
        </p>

        <h3>Ovatko Toriliven tallenteet saatavilla?</h3>
        <p>Toriliven kameran kuvaa ei tallenneta.</p>

        <h3>Haluaisitko pyytää meitä pyyhkimään kameran linssin?</h3>
        <p>
          Kameran linssi on onneksi koko ajan puhdas. Siihen emme valitettavasti voi vaikuttaa,
          kuinka puhtaat KOP-Kolmion ikkunat ovat, tai kuinka harmaa keli Turussa on.
        </p>

        <h3>Mihin voi lähettää palautetta?</h3>
        <p>
          Voit antaa palautetta Torilivestä
          <a href="https://www.taiste.fi/fi/ota-yhteytta" target="_blank">tämän lomakkeen kautta.</a>
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<style lang="stylus" scoped>

  @import '~vuetify/src/stylus/settings/_variables.styl'

  .more-info-card
    h3
      font-weight 500
      font-size 1.4em
      color: $green.accent-3

</style>
<script>

  export default {
    data: () => ({
      dialog: false,
    }),
  }

</script>
